import styled from 'styled-components';

import Text from '@/components/Text';

const Selections = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  margin: 24px 0;
`;

const ActionButton = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  width: 100%;
  border: 1px solid
    ${({ theme, $active }) =>
      $active ? theme.colors.purple : theme.colors.grayscale};
  border-radius: 4px;
  color: ${({ theme, $active }) =>
    $active ? theme.colors.purple : theme.colors.gray};
  cursor: pointer;
  transition: ease-out 0.2s;
  ${Text} {
    color: ${({ theme, $active }) =>
      $active ? theme.colors.purple : theme.colors.gray};
    transition: 0.2s ease-out;
  }
  &:hover {
    border-color: ${({ theme }) => theme.colors.purple};
    color: ${({ theme }) => theme.colors.purple};
    ${Text} {
      color: ${({ theme }) => theme.colors.purple};
    }
  }
`;

type SelectedAction = 'teamLeadActions' | 'returnToFreelancer' | 'rejectPayment' | null;

interface Props {
  selectedAction: SelectedAction;
  onSelect: (action: SelectedAction) => void;
}

const InvoiceUpdateModalActions = ({ selectedAction, onSelect }: Props) => {
  return (
    <Selections>
      <Text $type="smallBold">Actions:</Text>
      <ActionButton
        type="button"
        $active={selectedAction === 'teamLeadActions'}
        onClick={() =>
          onSelect(selectedAction === 'teamLeadActions' ? null : 'teamLeadActions')
        }
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M10 13C12.2091 13 14 11.2091 14 9C14 6.79086 12.2091 5 10 5C7.79086 5 6 6.79086 6 9C6 11.2091 7.79086 13 10 13Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.1818 1H1.81818C1.36631 1 1 1.36631 1 1.81818V18.1818C1 18.6337 1.36631 19 1.81818 19H18.1818C18.6337 19 19 18.6337 19 18.1818V1.81818C19 1.36631 18.6337 1 18.1818 1Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3 19C3.36184 17.2956 4.25147 15.7737 5.52319 14.6837C6.79491 13.5936 8.37335 13 10 13C11.6266 13 13.2051 13.5936 14.4768 14.6837C15.7485 15.7737 16.6382 17.2956 17 19"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <Text $type="captionSemibold">Make Team Lead actions</Text>
      </ActionButton>
      <ActionButton
        type="button"
        $active={selectedAction === 'returnToFreelancer'}
        onClick={() =>
          onSelect(selectedAction === 'returnToFreelancer' ? null : 'returnToFreelancer')
        }
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
        >
          <path
            d="M19.5 10H4.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.25 16.6654L4.5 9.9987L11.25 3.33203"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.5 17.4076V2.59277"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <Text $type="captionSemibold">Return to freelancer</Text>
      </ActionButton>
      <ActionButton
        type="button"
        $active={selectedAction === 'rejectPayment'}
        onClick={() =>
          onSelect(selectedAction === 'rejectPayment' ? null : 'rejectPayment')
        }
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
          />
          <path
            d="M13 6.99902L7 12.999"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13 12.999L7 6.99902"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <Text $type="captionSemibold">Reject payment permanently</Text>
      </ActionButton>
    </Selections>
  );
};

export default InvoiceUpdateModalActions;
